export default __webpack_public_path__ + "static/media/417.6d018b88.png";